export const VALIDATE = {
  _COMMON: {
    INPUT_REQUIRED: {
      MESSAGE: '入力してください',
    },
    SELECT_REQUIRED: {
      MESSAGE: '選択してください',
    },
    WHITESPACE_ONLY: {
      MESSAGE: '空白のみの入力はできません',
    },
    ZENKAKU_ONLY: {
      REGEX: {
        MESSAGE: '全角文字で入力してください',
      },
    },
    SJIS_CONVERTIBLE: {
      MESSAGE: '使用できない文字が含まれています',
    },
    NO_CHANGE: {
      MESSAGE: '現在と異なる内容を入力してください',
    },
    ONE_THOUSAND_CHARACTERS: {
      MAX: {
        VALUE: 1000,
        MESSAGE: '1000文字以下で入力してください',
      },
    },
    TWO_HUNDRED_FIFTY_FIVE_CHARACTERS: {
      MAX: {
        VALUE: 255,
        MESSAGE: '255文字以下で入力してください',
      },
    },
    ONE_HUNDRED_CHARACTERS: {
      MAX: {
        VALUE: 100,
        MESSAGE: '100文字以下で入力してください',
      },
    },
    SIXTY_CHARACTERS: {
      MAX: {
        VALUE: 60,
        MESSAGE: '60文字以下で入力してください',
      },
    },
    FIFTY_CHARACTERS: {
      MAX: {
        VALUE: 50,
        MESSAGE: '50文字以下で入力してください',
      },
    },
    THIRTY_CHARACTERS: {
      MAX: {
        VALUE: 30,
        MESSAGE: '30文字以下で入力してください',
      },
    },
    TWENTY_FIVE_CHARACTERS: {
      MAX: {
        VALUE: 25,
        MESSAGE: '25文字以下で入力してください',
      },
    },
    TWENTY_TWO_CHARACTERS: {
      MAX: {
        VALUE: 22,
        MESSAGE: '22文字以下で入力してください',
      },
    },
    TWENTY_THREE_CHARACTERS: {
      MAX: {
        VALUE: 23,
        MESSAGE: '23文字以下で入力してください',
      },
    },
    TEN_CHARACTERS: {
      MAX: {
        VALUE: 10,
        MESSAGE: '10文字以下で入力してください',
      },
    },
    SIXTY_FOUR_CHARACTERS: {
      MAX: {
        VALUE: 64,
        MESSAGE: '64文字以下で入力してください',
      },
    },
  },
  EMAIL: {
    FORMAT: {
      MESSAGE: 'メールアドレスを正しく入力してください',
    },
  },
  AMOUNT: {
    MAX: {
      VALUE: 10_000_000_000,
      MESSAGE: '100億円以下で入力してください',
    },
    FIFTEEN_HUNDRED: {
      VALUE: 1_500,
      MESSAGE: '1,500円以下で入力してください',
    },
    ONE_MILLION: {
      VALUE: 1_000_000,
      MESSAGE: '100万円以下で入力してください',
    },
  },
  URL: {
    FORMAT: {
      MESSAGE: '有効なURLを入力してください',
    },
  },
  APPROVERS: {
    SELECT_REQUIRED: {
      MESSAGE: '承認者を選択してください',
    },
  },
  PHONE_NUMBER: {
    REGEX: {
      VALUE: /^[0-9|０-９]{1,4}[-]?[0-9|０-９]{1,4}[-]?[0-9|０-９]{3,4}$/,
      MESSAGE: '電話番号を正しく入力してください',
    },
  },
  PASSWORD: {
    REGEX: {
      VALUE: /^(?=.*[a-zA-Z])(?=.*[0-9])[a-zA-Z|0-9|!-/|:-@|[-`|{-~|¥]{8,128}$/,
      MESSAGE: 'パスワードは8文字以上で、半角英数を組み合わせてください。',
    },
  },
  POSTAL_CODE: {
    REGEX: {
      VALUE: /^[0-9]{7}$/,
      MESSAGE: '7桁の半角数字で入力してください',
    },
  },
  CHALLENGE_CODE: {
    MESSAGE: '認証コードが未入力、または間違っています',
  },
  ZENGIN_FOR_PAYMENT_REQUESTS: {
    REGEX: {
      // eslint-disable-next-line no-irregular-whitespace
      VALUE: /^[a-zA-Z0-9ａ-ｚＡ-Ｚ０-９ァ-ヶｦ-ﾟー－\-()（）．.ｰ\sﾞﾟ　]+$/,
      MESSAGE:
        '全角・半角の英数字カナ・スペース/一部の記号（(), （）, ．, ., ー, －, -, ｰ, ﾞ, ﾟ ）で入力してください',
    },
    AMOUNT: {
      MAX: {
        VALUE: 9_999_999_999,
        MESSAGE: '100億円未満で入力してください',
      },
    },
  },
}
